import { DEFAULT_SEC_TREE_ROOT } from './constants';

export interface ITreeNode {
  uid: string;
  friendlyName?: React.ReactNode;
  children?: ITreeNode[];
}

export const findNode = (node: ITreeNode, id: string): ITreeNode | null => {
  if (node.uid === id) {
    return node;
  }

  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      const match = findNode(child, id);

      if (match) {
        return match;
      }
    }
  }

  return null;
};

export const findPathToNode = (
  node: ITreeNode,
  targetId: string,
  path: string[] = []
): string[] | null => {
  const currentPath = [...path, node.uid];

  if (node.uid === targetId) {
    return currentPath;
  }

  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      const result = findPathToNode(child, targetId, currentPath);

      if (result) {
        return result;
      }
    }
  }

  return null;
};

export const getExpandedNodeIds = (
  hierarchy: ITreeNode | null | undefined,
  selectedId: string
): string[] => {
  if (!hierarchy?.uid) {
    return [DEFAULT_SEC_TREE_ROOT];
  }

  const path = findPathToNode(hierarchy, selectedId);

  if (!path) {
    return [DEFAULT_SEC_TREE_ROOT];
  }

  return path.slice(0, -1);
};

export const mergeExpanded = (current: string[], next: string[]) =>
  Array.from(new Set([...current, ...next]));

export const resolveTreeItemFromQuery = (
  rootFromQuery: string | null,
  hierarchy: ITreeNode | null | undefined
): string => {
  if (!rootFromQuery) {
    return DEFAULT_SEC_TREE_ROOT;
  }

  if (!hierarchy?.uid) {
    return rootFromQuery;
  }

  if (findPathToNode(hierarchy, rootFromQuery)) {
    return rootFromQuery;
  }

  return DEFAULT_SEC_TREE_ROOT;
};

export const getNodeLabel = (
  hierarchy: ITreeNode | Record<string, unknown> | null | undefined,
  nodeId: string
): string => {
  const root = hierarchy as ITreeNode;

  if (!root?.uid) {
    return '';
  }

  const node = findNode(root, nodeId);
  const { friendlyName } = node || {};

  if (friendlyName == null || friendlyName === '') {
    return '';
  }

  return typeof friendlyName === 'string' ? friendlyName : String(friendlyName);
};
